import React from 'react';
import { TextField, Box, InputAdornment, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch } from 'react-redux';
import { setIsNewWorkshop } from '../../../redux/slices/editModeSlice';

const SearchToolbar = ({ searchQuery, setSearchQuery, selectedStatuses, setSelectedStatuses }) => {
  const statusOptions = ['Ongoing', 'Upcoming', 'Completed'];

  const handleStatusChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStatuses(typeof value === 'string' ? value.split(',') : value);
  };
  const dispatch = useDispatch();

  const handleCreateWorkshopClick = () => {
    dispatch(setIsNewWorkshop(true));
  };

  return (
    <Box
      sx={{
        padding: '0px',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between', // Align items and space between
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <TextField
          variant="outlined"
          placeholder="Search…"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            width: '350px',
            '& .MuiOutlinedInput-root': {
              border: '1px solid #E6E6E6',
              backgroundColor: '#FAFAFA',
              color: '#7A7A7A',
              borderRadius: '8px',
              fontSize: '16px',
              '& .MuiOutlinedInput-input': {
                paddingY: '14px',
              },
            },
          }}
        />

        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="status-filter-label">Filter Status</InputLabel>
          <Select
            labelId="status-filter-label"
            multiple
            value={selectedStatuses}
            onChange={handleStatusChange}
            input={<OutlinedInput label="Filter Status" />}
            renderValue={(selected) => selected.length === 0 ? "All" : selected.join(', ')}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
              height: '48px',
              borderRadius: '8px',
              backgroundColor: '#FAFAFA',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#E6E6E6',
              },
            }}
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                <Checkbox checked={selectedStatuses.indexOf(status) > -1} />
                <ListItemText primary={status} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Button
        variant="contained"
        sx={{
          backgroundColor: '#3F3F3F',
          minWidth: '170px',
          padding: '12px 16px',
          color: '#fff',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '16px',
          borderRadius: '12px',
          '&:hover': {
            backgroundColor: '#222',
          },
        }}
        startIcon={<AddCircleOutlineIcon />}
        onClick={handleCreateWorkshopClick} // Add the onClick handler
      >
        Create Workshop
      </Button>
    </Box>
  );
};

export default SearchToolbar;
